import OTP from './OTP'

export default OTP